import React, { useMemo } from 'react';
import { Case } from '../../../../graphql/graphql';

interface Props {
	item: Case;
}

const ATTENDING_DOCTOR_RELATION_TYPE = 8;

const MonitoringCenterAttendingDoctorColumn: React.FC<Props> = ({ item }) => {
	const relations = item.patient?.userRelations;

	return useMemo(() => {
		const rels = relations ?? [];
		if (rels.length === 0) return null;

		const relation =
			rels.find(ur => Number(ur.type) === ATTENDING_DOCTOR_RELATION_TYPE) ??
			rels[0];

		const profile = relation?.relationUser?.profile;
		if (!profile) return null;

		return [profile.salutationBefore, profile.lastName]
			.filter(Boolean)
			.join(' ');
	}, [relations]);
};

export default MonitoringCenterAttendingDoctorColumn;
